












































































import { Vue, Component } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { UI_SET_SHOW_STRENGTH_INDICATOR } from '@/store/ui/constants'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'passwords-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class PasswordsPanel extends Vue {
    @State((state: RootState) => state.ui.showStrengthIndicator)
    showStrengthIndicator!: boolean

    @Mutation(UI_SET_SHOW_STRENGTH_INDICATOR)
    setShowStrengthIndicator!: (showStrengthIndicator: boolean) => void
}
